module.exports = __webpack_public_path__ + "76ed368c362440f37fc41a4567ceb6dc.MP3";